module.exports = __webpack_public_path__ + "assets/icons/app-logo.104e8a06cdbf179fcf9a0e4aafbd737f.svg";